import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PageContext from '../../../config/page-settings.js';

import PaynamicsTransactionList from './PaynamicsTransactionList';

const PaynamicsTransactions = (props) => {
  const pageContext = useContext(PageContext);

  useEffect(() => {
    pageContext.handleSetPageSidebar(true);
    pageContext.handleSetPageHeader(true);
    pageContext.handleSetPageContentFullWidth(false);
  }, []);

  return (
    <div>
      <h1 className="page-header">Paynamics Transactions</h1>
      <PaynamicsTransactionList />
    </div>
  );
};

export default withRouter(PaynamicsTransactions);
